var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotography(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.321 69.217a21.74 21.74 0 0 0-1.186-3.475 15.916 15.916 0 0 0-2.905-11.494l4.265-4.096a15.917 15.917 0 0 0-12.862-27.257l-5.476.643a15.914 15.914 0 0 0-20.359-7.951l-1.994-4.207a15.915 15.915 0 0 0-14.415-9.103 15.911 15.911 0 0 0-14.378 9.165l-1.788 3.813-4.284-2.086a15.912 15.912 0 0 0-22.693 11.802 15.92 15.92 0 0 0 1.485 9.63l1.207 2.4a15.95 15.95 0 0 0-6.775 11.601 18.842 18.842 0 0 0-12.915 8.008l-.187-.037a40.343 40.343 0 0 0-29.91 6.671 40.36 40.36 0 0 0-10.311 55.764 40.34 40.34 0 0 0 25.547 16.925l1.078.211.812.159 105.982 20.708a15.916 15.916 0 0 0 18.671-12.57l10.999-56.292a18.798 18.798 0 0 0-7.608-18.932Z",
    fill: "#F1F333",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.734 141.489-105.54-20.622M83.342 74.32l1.464-7.493a2.855 2.855 0 0 1 3.348-2.254l88.776 17.346a2.85 2.85 0 0 1 2.249 3.348l-10.999 56.291",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.304 120.499c13.247 2.588 26.084-6.055 28.673-19.304 2.588-13.25-6.051-26.088-19.298-28.676-13.246-2.589-26.083 6.054-28.672 19.303-2.589 13.25 6.05 26.088 19.297 28.677Z",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.296 126.34a24.436 24.436 0 0 0 18.333-3.713 24.447 24.447 0 0 0 6.629-33.927 24.436 24.436 0 0 0-15.587-10.34L69.684 72.5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.401 86.097a18.569 18.569 0 0 1 18.956-7.833M46.66 100.516a18.574 18.574 0 0 1-.09-7.586",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.465 68.844 3.727-19.075a7.526 7.526 0 0 1 8.832-5.95l17.857 3.489a7.53 7.53 0 0 1 5.943 8.837l-15.455 79.1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.864 50.265 12.85-4.858-8.89-17.76 18.812 9.168 8.644-18.46 9.074 19.175 13.274-7.024-1.712 11.116 23.427-2.753-14.659 14.084 8.562 10.869-69.382-13.557Zm.657 28.675 44.773 8.748 6.661 6.572a23.662 23.662 0 0 0 11.07 5.445l11.454 2.238m-50.488 24.782a4.945 4.945 0 1 0 1.894-9.706 4.945 4.945 0 0 0-1.894 9.706Zm42.099-57.868a6.025 6.025 0 0 1 4.748 7.069l-.884 4.525-11.818-2.31.884-4.524a6.029 6.029 0 0 1 7.07-4.76v0Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h224v160H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/Photography.ac435424d77b1059665a2971a976cdf5.svg";
export { ForwardRef as ReactComponent };